export default __webpack_public_path__ + "static/media/icon_doublechevron_left.66225a94.svg";